import { PJ_CONSTANTS } from './_props'

export const MAX_FILES = PJ_CONSTANTS.MAX_FILES
export const MAX_BYTES = PJ_CONSTANTS.MAX_BYTES

export const isFileSizeValid = (file: File) => file.size <= MAX_BYTES

export const modalStateDefaultValues = {
    open: false,
}

export const RENAME_DIALOG_MAX_LENGTH = 35

export const invalidCharsError = 'Les caractères spéciaux (par exemple “, ?, &,...) ne sont pas supportés'

export const checkInvalidChars = (value: string) => {
    const cleanedValue = value.replace(/[^\p{L}\p{N}._ -]/gu, '')

    return cleanedValue !== value
}
